var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import { TextArea } from 'elements';
class FieldTextArea extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (event) => {
            const value = event.target.value.replace(/[\n\r]{2,}/g, '');
            this.props.onChange(this.props.name, value, this.props.column);
        };
    }
    render() {
        const _a = this.props, { name, type, value, required, onChange } = _a, props = __rest(_a, ["name", "type", "value", "required", "onChange"]);
        return (React.createElement(TextArea, Object.assign({}, props, { label: t(name) + (required ? '*' : ''), type: type, value: value, className: className, onChange: this.handleChange })));
    }
}
export default FieldTextArea;
const className = cxs({
    padding: Theme.size.space[1]
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldTextArea.tsx
// module id = 380
// module chunks = 0